import {
	PHARMACY_DELIVERY_DRIVERS_LIST_REQUEST,
	PHARMACY_DELIVERY_DRIVERS_LIST_SUCCESS,
	PHARMACY_DELIVERY_DRIVERS_LIST_FAILURE
} from '../../../constants';

const initialState = {
	data: null,
	loading: false,
	error: null,
};

const deliveryDriversListReducer = (state = initialState, action) => {
	switch (action.type) {
		case PHARMACY_DELIVERY_DRIVERS_LIST_REQUEST:
			return {
				...state,
				loading: true,
				data: null,
				error: null,
			};
		case PHARMACY_DELIVERY_DRIVERS_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
		case PHARMACY_DELIVERY_DRIVERS_LIST_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null,
			};
		default:
			return state;
	}
};

export default deliveryDriversListReducer;
